import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { NumberConfig } from '../../../config/NumberConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../../config/RulesConfigDescriptionLocalizable';
import { MGPValidators } from '../../../utils/MGPValidator';
import { AbstractCheckersRules, CheckersOptionLocalizable } from '../common/AbstractCheckersRules';
export class LascaRules extends AbstractCheckersRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `Lasca`,
        config: {
            playerRows: new NumberConfig(3, RulesConfigDescriptionLocalizable.NUMBER_OF_PIECES_ROWS, MGPValidators.range(1, 99)),
            emptyRows: new NumberConfig(1, RulesConfigDescriptionLocalizable.NUMBER_OF_EMPTY_ROWS, MGPValidators.range(1, 99)),
            width: new NumberConfig(7, RulesConfigDescriptionLocalizable.WIDTH, MGPValidators.range(2, 99)),
            canStackPieces: new BooleanConfig(true, CheckersOptionLocalizable.STACK_PIECES),
            mustMakeMaximalCapture: new BooleanConfig(false, CheckersOptionLocalizable.MAXIMAL_CAPTURE),
            simplePieceCanCaptureBackwards: new BooleanConfig(false, CheckersOptionLocalizable.SIMPLE_PIECE_CAN_CAPTURE_BACKWARDS),
            promotedPiecesCanFly: new BooleanConfig(false, CheckersOptionLocalizable.PROMOTED_PIECES_CAN_TRAVEL_LONG_DISTANCES),
            occupyEvenSquare: new BooleanConfig(true, CheckersOptionLocalizable.OCCUPY_EVEN_SQUARE),
            frisianCaptureAllowed: new BooleanConfig(false, CheckersOptionLocalizable.FRISIAN_CAPTURE_ALLOWED),
            canPromoteMidCapture: new BooleanConfig(false, CheckersOptionLocalizable.CAN_PROMOTE_MID_CAPTURE),
        },
    });
    static get() {
        if (LascaRules.singleton.isAbsent()) {
            LascaRules.singleton = MGPOptional.of(new LascaRules());
        }
        return LascaRules.singleton.get();
    }
    getRulesConfigDescription() {
        return LascaRules.RULES_CONFIG_DESCRIPTION;
    }
}
